import React from 'react'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import { hideAnimationForm } from '../../store/action/animationForm';
import Header from '../Header';
import { tempFetchCatalog } from '../../store/action/authorization';

class AnimationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: props.valueForm,
      show: false,
      filterData: [],
      searchText: ''
    };
    this.TextList = props.derictory || {}
  }

  componentDidMount(){
    // this.props.onFetDir()
  }
  componentWillUnmount(){
    this.setState({
      active: '',
      searchText: '',
      show: false,
      filterData: []
    })
  }
  componentDidUpdate(prevProps){
    if(this.props.nameForm !== prevProps.nameForm)
      this.setState({
        active: this.props.valueForm,
        sourse: this.TextList[this.props.nameForm]
      })
    if(Object.keys(this.TextList).length !== Object.keys(this.props.derictory).length)
      this.TextList = this.props.derictory
  }
  onClick = e => {
    const {nameForm, onHideForm, onSelect} = this.props
    onHideForm()
    onSelect(nameForm, e.target.value)
    this.setState({active: e.target.value, searchText: ''})
  }
  renderItemList = (id, value) => (
    <li
      key={id}
      className={`animation-form_item-list ${id === this.state.active && 'active'}`}
      onClick={this.onClick}
      value={id}
      type='button'
    >
      {value}
    </li>
  )
  checkStateForm = () => {
    const z = this
    if(this.props.show && !this.state.show)
      this.setState({show: true})
    else if(!this.props.show && this.state.show)
      setTimeout(() => {
        z.setState({show: false})
      }, 500)
  }
  renderSearchComponent = (title) => (
    <div className="serach-container">
      <input
        type="text"
        className="search"
        placeholder={title}
        onChange={this.onChangeSearch}
        value={this.state.searchText}
      />
    </div>
  )
  onChangeSearch = e => {
    const {nameForm} = this.props
    if(this.TextList[nameForm]){
      const filterList = this.TextList[nameForm].filter(itemData =>  {
        return itemData.nameUkr.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
      })
      this.setState({
        filterData: filterList,
        searchText: e.target.value
      })
    }
  }

  sourceData = () => {
    const {nameForm} = this.props
    const {filterData, searchText} = this.state
    if(this.TextList[nameForm])
      return searchText.length !== 0 ? filterData : this.TextList[nameForm]
    return []
  }
  close = () => {
    const {onHideForm} = this.props
    onHideForm()
    this.setState({searchText: ''})
  }
  render() {
    this.checkStateForm()
    const {nameForm, animeteFormTitle} = this.props
    const data = this.sourceData()

    return (
      <div className={`animation-form_content ${this.state.show ? 'active' : 'hidde'}`}>
        <CSSTransitionGroup
          transitionName="example"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {this.props.show && <div className='animation-form_content-container'>
            <Header title={animeteFormTitle} onClickBack={this.close}/>
            {nameForm === 'region' && this.renderSearchComponent('Пошук регіону')}
            {nameForm === 'ent_segment' && this.renderSearchComponent('Пошук сфери')}
            <ul className={`animation-form_item-list ${nameForm === 'region' && 'show-search'}`}>
              {data.map(item => this.renderItemList(item.catalogId, item.nameUkr))}
            </ul>
          </div>}
        </CSSTransitionGroup>
      </div>
    );
  }
}

AnimationForm.propTypes = {
  animeteFormTitle: PropTypes.string.isRequired,
  nameForm: PropTypes.string.isRequired,
  onHideForm: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valueForm: PropTypes.string.isRequired,
  derictory: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  show: state.animationForm.show,
  nameForm: state.animationForm.nameForm,
  state: state.animationForm,
  animeteFormTitle: state.animationForm.title,
  valueForm: state.animationForm.value,
  derictory: state.derictory
})

const mapDispatchToProps = dispatch => ({
  onHideForm: () => dispatch(hideAnimationForm()),
  onFetDir: () => dispatch(tempFetchCatalog())
})

export default connect(mapStateToProps, mapDispatchToProps)(AnimationForm)